import { FC } from 'react'
import { useNavigate } from 'react-router-dom'
import { IApiPagable, IPagesResponse } from '../../api/IPagesResponse'
import { IOrder } from '../../model/IOrder'
import parseISOToString from '../../utils/parseISOToString'
import Table, { ITableTh, TUpdatePageParams } from '../common/table/Table'
import TableSkeloton from '../common/skeletons/TableSkeloton'
import EmptyTable from '../common/empty/EmptyTable'
import { IOnSort } from '../../hooks/usePagable'
import { IPageParams } from '../../api/IApi'
import { getVendorListFromOrderItems } from '../../utils/getVendorListFromOrderItems'

const thead: ITableTh[] = [
  { title: 'Order#', sortCol: 'orderId' },
  { title: 'Vendor' },
  { title: 'Stock#' },
  { title: 'Invoice', sortCol: 'invoice' },
  { title: 'Street', sortCol: 'siStreet' },
  { title: 'City', sortCol: 'siCity' },
  { title: 'Name', sortCol: 'siName' },
  { title: 'Zip', sortCol: 'siZip' },
  { title: 'State', sortCol: 'siState' },
  { title: 'Phone', sortCol: 'siPhone' },
  { title: 'Create', sortCol: 'timeCreate' },
  { title: 'Update', sortCol: 'timeUpdate' },
]

const OrderUnshippedTable: FC<{
  isFetching?: boolean
  orders?: IPagesResponse<IOrder[]>
  loadTriggerComponent?: JSX.Element
  updatePageParams?: TUpdatePageParams
  pageParams?: IPageParams
  onSort?: IOnSort
}> = ({ isFetching, orders, loadTriggerComponent, onSort, pageParams, updatePageParams }) => {
  const navigate = useNavigate()

  return (
    <div className='flex flex-col gap-1 w-full h-full'>
      {(isFetching && !orders?.content && (
        <div className='flex w-full h-full justify-center items-start text-text'>
          <TableSkeloton />
        </div>
      )) ||
        (orders?.content && (
          <>
            <Table
              isPending={isFetching}
              pagable={orders}
              thead={thead}
              onSort={onSort}
              updatePageParams={updatePageParams}
              pageParams={pageParams}
              tbody={orders.content.map(
                ({
                  id,
                  orderId,
                  orderItems,
                  itemsStockNumbers,
                  invoice,
                  timeCreate,
                  timeUpdate,
                  siStreet,
                  siCity,
                  siName,
                  siZip,
                  siState,
                  siPhone,
                  siDate,
                }) => ({
                  onClick: () => navigate(`/orders/${orderId}`),
                  data: [
                    orderId,
                    getVendorListFromOrderItems(orderItems),
                    itemsStockNumbers,
                    invoice,
                    siStreet,
                    siCity,
                    siName,
                    siZip,
                    siState,
                    siPhone,
                    parseISOToString(timeCreate, false),
                    parseISOToString(timeUpdate, false),
                  ],
                }),
              )}
            />
            {loadTriggerComponent}
          </>
        )) || (
          <div className='flex w-full h-full py-4 justify-center items-center text-text'>
            <EmptyTable />
          </div>
        )}
    </div>
  )
}

export default OrderUnshippedTable
